module.exports = __webpack_public_path__ + "static/media/posbill-logo.951bb4b1.png";